import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'

const SvgReverseLeft = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M4 7h10a6 6 0 0 1 0 12H4M4 7l4-4M4 7l4 4"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgReverseLeft)
export default ForwardRef
